import { render, staticRenderFns } from "./treeDownList.vue?vue&type=template&id=923bfff4&scoped=true&"
import script from "./treeDownList.vue?vue&type=script&lang=js&"
export * from "./treeDownList.vue?vue&type=script&lang=js&"
import style0 from "./treeDownList.vue?vue&type=style&index=0&id=923bfff4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923bfff4",
  null
  
)

export default component.exports